import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";

const AddCompanyYard = ({ formRef, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [company, setCompany] = useState([]);
  const [rowAddData, setRowAddData] = useState({
    yard_name: "",
    company_id: "",
  });
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  // console.log(selectedMaterialId)

  const handleCompanyChange = (e) => {
    setSelectedCompanyId(e.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { yard_name } = rowAddData;

    let BASE_URL = SERVER_URL + `/api/com-yard/company-yards/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        yard_name,
        company_id: selectedCompanyId,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if(res.ok){
      setCompany(result.data);     
    }else{
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Company Yard
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Party Name</h4> */}
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="Company">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleCompanyChange}
                              value={selectedCompanyId}
                              id="Company"
                              required
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company?.length > 0 &&
                                company?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="Yard">Yard Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="yard_name"
                              id="Yard"
                              placeholder="Yard Name"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCompanyYard;
